module.exports = __webpack_public_path__ + "img/solutionBanner_3.33fb8638.png";